<template>
	<edit-template class="role-edit" ref="edit" @confirm="save" @cancel="open" :cancelRemind="false" confirmText="保存" cancelText="取消">
		
		<!-- 大表单 -->
		<div class="form-body" style="padding-top: 70rem">
			<el-form ref="form" :model="form" label-width="150rem" size="medium">
				<el-form-item label="校区" :rules="[{ required: true }]">
					<el-select :popper-append-to-body="false" v-model="form.school_id" placeholder="请选择" :disabled="userInfo.userinfo.type != 3" @change="changeSchool">
						<el-option v-for="(item, index) in this.schoolList" :label="item" :value="index" :key="index">
							{{ item }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属教学楼" :rules="[{ required: true }]">
					<el-select disabled="" :popper-append-to-body="false" v-model="form.buliding_id" placeholder="请选择" @change="strValChange">
						<el-option v-for="i in floorData" :label="i.dimicile_buliding_name" :value="i.id" :key="i.id">
							{{ i.dimicile_buliding_name }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="楼层" :rules="[{ required: true }]">
					<el-select :popper-append-to-body="false" v-model="form.storey" placeholder="请选择">
						<el-option v-for="i in floorList" :value="i" :label="i" :key="i">{{ i }}</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="教室名称" :rules="[{ required: true }]">
					<el-input type="text" v-model="form.classroom_name" placeholder="请输入" style="width: 215rem" @input="classroomnameChange"></el-input><span style="margin-left: 24rem; font-size: 12rem; color: red" v-if="classroom_name_show">教室名称仅限15个字</span>
				</el-form-item>
				<el-form-item label="最大容纳人数" :rules="[{ required: true }]">
					<el-input v-model.number="form.max_number" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" type="number" :maxlength="8" placeholder="请输入" style="width: 215rem"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<!-- 底部按钮 -->
		
	
</edit-template>
</template>

<script>
import { building, classroomEdit, classroomDetail } from '@/api/school'
import { mapGetters } from 'vuex'

export default {
	_config:{"route":{"path":"edit","meta":{"title":"编辑"}}},
  data() {
		return {
			checkData: [],
			schoolList: [],
			form: {
				school_id: null,
				buliding_id: null,
				storey: null,
				classroom_name: null,
				max_number: null
			},
			floorData: [],
			floorList: [],
			classroom_name_show: false
		}
	},
	computed: {
		...mapGetters(['userInfo'])
	},

	methods: {
		/**
		 * @description 更改校区
		 * @param val
		 */
		changeSchool(val) {
			this.form.buliding_id = ''
			this.form.storey = ''
			building(val).then(res => {
				this.floorData = res.data.data
			})
		},
		strValChange(value) {
			this.form.storey = ''
			this.floorData.forEach(i => {
				if (i.id == value) {
					let min = i.floor_min
					let max = i.floor_max
					this.floorList = []
					for (min; min <= max; min++) {
						if (min !== 0) {
							this.floorList.push(min)
						}
					}
				}
			})
		},
		save() {
			let { school_id, buliding_id, storey, classroom_name, max_number } = this.form
			let { checkInput } = this.$tools
			if (checkInput('empty', school_id)) {
				return this.$message.warning('请选择校区')
			} else if (checkInput('empty', buliding_id)) return this.$message.warning('请选择教学楼')
			else if (checkInput('empty', storey)) return this.$message.warning('请选择楼层')
			else if (checkInput('empty', classroom_name)) return this.$message.warning('请输入教室名')
			else if (checkInput('empty', max_number) || max_number < 0) return this.$message.warning('请输入最大容纳人数 , 且不允许小于0')
			else if (this.classroom_name_show) return this.$message.warning('教室名称仅限15个字')
			classroomEdit(this.form).then(res => {
				if (res.data.error.errorCode === 0) {
					this.$router.back()
				}
			})
		},
		open() {
			this.$confirm('是否取消编辑', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.$router.back()
				})
				.catch(() => {})
		},
		init() {
			let { userinfo, school_arr } = this.userInfo
			this.$utils.commonApi.getSchoolList().then(res => {
				this.schoolList = res
			})
			if (userinfo.type !== '3') {
				let id = ''
				for (let i in school_arr) {
					id = i
				}
				this.schoolList = school_arr
				this.form.school_id = id
			}
		},
		classroomnameChange(value) {
			if (value.length > 15) {
				this.classroom_name_show = true
			} else {
				this.classroom_name_show = false
			}
		}
	},

	created() {
		this.init()
		classroomDetail({ id: this.$route.query.id }).then(result => {
			this.form = result.data.data
			let min = this.form.floor_min
			let max = this.form.floor_max
			this.floorList = []
			for (min; min <= max; min++) {
				if (min !== 0) {
					this.floorList.push(min)
				}
			}
			building(this.form.school_id).then(res => {
				this.floorData = res.data.data
			})
		})
	}
}
</script>

<style lang="scss" scoped>
.checkbox {
	min-width: 100rem;
	margin: 10rem;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
	-webkit-appearance: none !important;
}
::v-deep input[type='number'] {
	-moz-appearance: textfield !important;
}
</style>
